import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";

import "assets/scss/custom/_darkmode.scss";
import "assets/scss/custom/_tablesearch.scss";
import "assets/css/argon-dashboard-pro-react.css";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";
import Invite from "views/pages/examples/Invite";
import Dealer from "layouts/Dealer";
import { KeycloakContext, keycloak } from 'variables/keycloak';

keycloak.init({
  onLoad: "login-required",
  checkLoginIframe: false
}).then(auth => {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <KeycloakContext.Provider value={keycloak}>
      <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/auth/*" element={<Auth />} />
          <Route path="/dealer/*" element={<Dealer />} /> 
          <Route path="/" element={<Navigate to="/auth/login" replace />} />
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
          <Route path="/invite" element={<Invite />} />
        </Routes>
      </BrowserRouter>
      </ThemeProvider>
    </KeycloakContext.Provider>
  );
}).catch(err => console.error('Keycloak init failed', err));